import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const LoadingContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '100vh',
  backgroundColor: '#F7FAFC',
  gap: theme.spacing(2),
}));

const LoadingScreen: React.FC = () => {
  return (
    <LoadingContainer>
      <CircularProgress size={60} color="primary" />
      <Typography variant="h6" color="textSecondary">
        Loading Aletheia Admin Portal...
      </Typography>
    </LoadingContainer>
  );
};

export default LoadingScreen;
